<template>
  <div class="container-order-info">
    <h4 class="container-order-info__main-title">{{$t('order_information')}}</h4>
    <template v-if="isLoading">
        <div class="is-loading"></div>
    </template>
    <template v-else>
        <template v-if="!isRoundTrip">
            <RoundTripFalseWrapperComponent :order-data="orderData"></RoundTripFalseWrapperComponent>
        </template>
        <template v-else>
            <RoundTripTrueWrapperComponent :order-data="orderData"></RoundTripTrueWrapperComponent>
        </template>
    </template>
  </div>
</template>

<script>
import './transportationOrderInfo.scss';
import {defineComponent} from "vue";
// @ts-ignore
import RoundTripFalseWrapperComponent from "../transportationOrderInfo/roundTripFalseWrapper/RoundTripFalseWrapperComponent.vue";
// @ts-ignore
import RoundTripTrueWrapperComponent from "../transportationOrderInfo/roundTripTrueWrapper/RoundTripTrueWrapperComponent.vue";

export default defineComponent({
  name: 'TransportationOrderInfoComponent',
  components: {
    RoundTripFalseWrapperComponent,
    RoundTripTrueWrapperComponent

  },
  props: {
    orderData: {
      type: Object,
    },
    isRoundTrip: {
      type: [Boolean, null],
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
})

</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

.is-loading {
  width: 3rem;
  height: 3rem;
  border: 5px solid $white;
  border-bottom-color: $blue;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-bottom: 2.25rem;
}

</style>